import { render, staticRenderFns } from "./DocumentationForm.vue?vue&type=template&id=48753da4&scoped=true"
import script from "./DocumentationForm.vue?vue&type=script&lang=js"
export * from "./DocumentationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48753da4",
  null
  
)

export default component.exports